<template>
  <div>
    <b-modal
      id="AirAssignment-modal"
      ref="AirAssignment-modal"
      size="lg"
      hide-footer
      :title="`Air Assignment Job Type Management - ${mu_jb_series}`"
    >
      <b-row class="m-2">
        <b-col cols="12" class="mb-3">
          
          <b-row class="align-items-center">
            <b-col md="3">
              <label class="mb-0"><b>Column Name</b></label>
            </b-col>
            <b-col md="5">
              <model-list-select
                :list="columnNameOptions"
                v-model="selectedColumnName"
                option-value="value"
                option-text="text"
                placeholder="Select Column Name"
               />
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <b-row v-if="selectedColumnName === 'CLIENT'">
            <b-col md="6">
              <label><b>Client Name</b></label>
              <model-list-select
                :list="$store.getters['common/getAllClientList']"
                v-model="multiUpdateDetail.clientId"
                option-value="clientId"
                option-text="clientName"
                placeholder="Select Existing Client Name"
               />
            </b-col>
            <b-col md="6" class="mt-4">
              <label><b>Old Client Name:</b> {{ getOldValue("TPTClient") }}</label>
            </b-col>
          </b-row>

          <b-row v-if="selectedColumnName === 'Importer Client'">
            <b-col md="6">
              <label><b>Importer Client</b></label>
              <model-list-select
                :list="$store.getters['common/getAllClientList']"
                v-model="multiUpdateDetail.importerClientId"
                option-value="clientId"
                option-text="clientName"
                placeholder="Select Existing Importer Client"
               />
            </b-col>
            <b-col md="6" class="mt-4">
              <label><b>Old Importer Client:</b> {{ getOldValue("importer") }}</label>
            </b-col>
          </b-row>

          <b-row v-if="selectedColumnName === 'Exporter Client'">
            <b-col md="6">
              <label><b>Exporter Client</b></label>
              <model-list-select
                :list="$store.getters['common/getAllClientList']"
                v-model="multiUpdateDetail.exporterClientId"
                option-value="clientId"
                option-text="clientName"
                placeholder="Select Existing Exporter Client"
               />
            </b-col>
            <b-col md="6" class="mt-4">
              <label><b>Old Exporter Client:</b> {{ getOldValue("exporter") }}</label>
            </b-col>
          </b-row>

          <b-row v-if="selectedColumnName === 'Airline'">
            <b-col md="6">
              <label><b>Airline</b></label>
              <model-list-select
                :list="$store.getters['common/getAllAirLineList']"
                v-model="multiUpdateDetail.airlineId"
                option-value="airlineId"
                option-text="airlineName"
                placeholder="Select Airline"
               />
            </b-col>
            <b-col md="6" class="mt-4">
              <label><b>Old Airline:</b> {{ getOldValue("airLine") }}</label>
            </b-col>
          </b-row>

          <b-row v-if="selectedColumnName === 'Airport of Departure'">
            <b-col md="6">
              <label><b>Airport of Departure (Handover)</b></label>
              <model-list-select
                :list="$store.getters['common/getAllAirPortDepartureList']"
                v-model="multiUpdateDetail.airportDeparture"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Airport of Departure"
               />
            </b-col>
            <b-col md="6" class="mt-4">
              <label><b>Old Airport of Departure:</b> {{ getOldValue("AirDept") }}</label>
            </b-col>
          </b-row>

          <b-row v-if="selectedColumnName === 'Airport of Destination'">
            <b-col md="6">
              <label><b>Airport of Destination</b></label>
              <model-list-select
                :list="$store.getters['common/getAllAirPortDestinationList']"
                v-model="multiUpdateDetail.airportDestination"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Airport of Destination"
               />
            </b-col>
            <b-col md="6" class="mt-4">
              <label><b>Old Airport of Destination:</b> {{ getOldValue("airDesti") }}</label>
            </b-col>
          </b-row>

          <b-row v-if="selectedColumnName === 'ENQUIRY ID'">
            <b-col md="6">
              <label><b>ENQUIRY ID</b></label>
              <model-list-select
                :list="$store.getters['commonDropdownMaster/getAllENQDDList']"
                v-model="multiUpdateDetail.mainEnquiryId"
                option-value="mainEnquiryId"
                option-text="mainEnquirySeries"
                placeholder="Select ENQUIRY No"
               />
            </b-col>
            <b-col md="6" class="mt-4">
              <label><b>Old ENQUIRY ID:</b> {{ getOldValue("mainEnquirySeries") }}</label>
            </b-col>
          </b-row>

          <b-row v-if="selectedColumnName === 'Booking No (CT JOB)'">
            <b-col md="6">
              <label><b>Booking No (CT JOB)</b></label>
              <b-form-input
                v-model="multiUpdateDetail.validBookingNo"
                placeholder="Enter Booking No"
               />
            </b-col>
            <b-col md="6" class="mt-4">
              <label><b>Old Booking No:</b> {{ getOldValue("validBookingNo") }}</label>
            </b-col>
          </b-row>

          <div v-if="selectedColumnName === 'JOB CHANGE'">
          <h5>Enquiry Job Types</h5>
          <table class="table table-bordered table-sm">
            <thead>
              <tr>
                <th>Job Type</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(segment, idx) in displayedSegments" :key="'seg-' + idx">
                <td>{{ segment.show }}</td>
                <td>
                  <b-badge :variant="newJobType.includes(segment.value) ? 'success' : 'danger'">
                    {{ newJobType.includes(segment.value) ? 'Included' : 'Excluded' }}
                  </b-badge>
                </td>
                <td>
                  <md-checkbox
                    v-model="checkboxFlags[idx]"
                    class="md-primary"
                    @change="toggleJob(segment.value)"
                  >
                    {{ newJobType.includes(segment.value) ? 'Exclude' : 'Include' }}
                  </md-checkbox>
                </td>
              </tr>
              <tr v-if="displayedSegments.length === 0">
                <td colspan="3" class="text-center text-muted">No Job Types available for this assignment.</td>
              </tr>
            </tbody>
          </table>
          </div>
        </b-col>
      </b-row>
      
      <div class="modal-footer">
        <b-button variant="secondary" @click="hideModal">Close</b-button>
        <b-button variant="primary" @click="SaveMultiUpdate" :disabled="isLoading || !selectedColumnName || (selectedColumnName === 'JOB CHANGE' && newJobType.length === 0)">
          <b-spinner small v-if="isLoading"></b-spinner>
          Save Changes
        </b-button>
      </div>
    </b-modal>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    />
  </div>
</template>

<script>
import AirExpImpService from "../../services/AirExpImpService";
import { ModelListSelect } from "vue-search-select";

export default {
  name: "AirAssignmentModal",
  components: {
    ModelListSelect,
  },
  props: {
    mu_all_module_id: { type: [String, Number], default: "" },
    mu_jb_series: { type: String, default: "" },
    mu_assign_job_type: { type: String, default: "" },
    mu_enq_job_type: { type: String, default: "" },
    mu_client_id: { type: [String, Number], default: "" },
    mu_item: { type: Object, default: () => {} },
  },
  beforeMount() {
    this.$store.dispatch("common/setAllClientList", JSON.stringify({ itemCode: "ClientList" }));
    this.$store.dispatch("commonDropdownMaster/setAllENQDDList",JSON.stringify({itemCode: "ENQList",client_id: this.mu_client_id}));
    this.$store.dispatch("common/setAllAirLineList",JSON.stringify({itemCode: "AirLineList"}));
    this.$store.dispatch("common/setAllAirPortDepartureList",JSON.stringify({itemCode: "AirPortDepartureList"}));
    this.$store.dispatch("common/setAllAirPortDestinationList",JSON.stringify({itemCode: "AirPortDestinationList"}));
  },
  data() {
    return {
      isLoading: false,
      newJobType: [],
      minusJob: [],
      checkboxFlags: [],
      displayedSegments: [],
      showSegmentArray: [
        { value: "FF", show: "FREIGHT FORWARDING (FF)" },
        { value: "CC", show: "CUSTOM CLEARANCE (CC)" },
        { value: "TPT", show: "TRANSPORTATION (TPT)" },
      ],
      enquiryJobTypes: [],
      alert: {
        content: "",
        ok: "ok",
      },
      allAssignmentMultiUpdateData: [],
      selectedColumnName: "JOB CHANGE",
      multiUpdateDetail: {
        clientId: "",
        importerClientId: "",
        exporterClientId: "",
        airlineId: "",
        airportDeparture: "",
        airportDestination: "",
        mainEnquiryId: "",
        validBookingNo: "",
      },
      columnNameOptions: [
        { value: "JOB CHANGE", text: "SERVICE CHANGE" },
        { value: "CLIENT", text: "CLIENT" },
        { value: "Importer Client", text: "Importer Client" },
        { value: "Exporter Client", text: "Exporter Client" },
        { value: "Airline", text: "Airline" },
        { value: "Airport of Departure", text: "Airport of Departure (Handover)" },
        { value: "Airport of Destination", text: "Airport of Destination" },
        { value: "ENQUIRY ID", text: "ENQUIRY ID" },
        { value: "Booking No (CT JOB)", text: "Booking No (CT JOB)" },
      ],
    };
  },
  watch: {
    mu_all_module_id(newVal) {
      if (newVal) {
        this.getAssignmentDetails();
      }
    },
    mu_enq_job_type(newVal) {
      this.syncEnquiryJobTypes(newVal);
      this.syncDisplayedSegments();
    }
  },
  computed: {
  },
  methods: {
    showAlert(message) {
      this.alert.content = message;
      this.$refs["addPop"].open();
    },
    showModal() {
      // Initialize from props for immediate feedback
      this.newJobType = this.normalizeJobs(this.mu_assign_job_type);
      this.multiUpdateDetail = {
        clientId: "",
        importerClientId: "",
        exporterClientId: "",
        airlineId: "",
        airportDeparture: "",
        airportDestination: "",
        mainEnquiryId: "",
        validBookingNo: "",
      };
      this.syncEnquiryJobTypes(this.mu_enq_job_type);
      this.syncDisplayedSegments();
      this.syncCheckboxes();
      
      this.$refs["AirAssignment-modal"].show();
      if (this.mu_client_id) {
        this.$store.dispatch(
          "commonDropdownMaster/setAllENQDDList",
          JSON.stringify({
            itemCode: "ENQList",
            client_id: this.mu_client_id,
          })
        );
      }
      this.getAssignmentDetails();
    },
    hideModal() {
      this.$refs["AirAssignment-modal"].hide();
    },
    getAssignmentDetails() {
      let AssignmentMultiUpdate = {
        filter: "getAssignmentMultiUpdate",
        allModuleId: this.mu_all_module_id,
      };
      this.isLoading = true;
      AirExpImpService.getAssignmentDetails(JSON.stringify(AssignmentMultiUpdate))
        .then((result) => {
          const { status, data } = result;
          if (status == 200 && data) {
            if (data.AssignmentSummaryData.length > 0) {
              this.allAssignmentMultiUpdateData = data.AssignmentSummaryData;
              const currentJobs = data.AssignmentSummaryData[0].NewJobTypesArr || data.AssignmentSummaryData[0].JobTypes || [];
              this.newJobType = this.normalizeJobs(currentJobs);
              
              if (data.AssignmentSummaryData[0].JobTypesInEnquiry) {
                 this.syncEnquiryJobTypes(data.AssignmentSummaryData[0].JobTypesInEnquiry);
              }
              
              this.syncDisplayedSegments();
              this.syncCheckboxes();
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("Error fetching assignment details:", error);
        }).finally(() => {
          this.isLoading = false;
        });
    },
    getOldValue(key) {
      if (!this.mu_item) return "";
      return this.mu_item[key] || "";
    },
    syncEnquiryJobTypes(jobsStr) {
      this.enquiryJobTypes = this.normalizeJobs(jobsStr);
    },
    normalizeJobs(jobs) {
      if (!jobs) return [];
      let jobsArr = Array.isArray(jobs) ? jobs : jobs.split(',');
      const possible = ['FF', 'CC', 'TPT'];
      let result = [];
      jobsArr.forEach(j => {
        if (typeof j !== 'string') return;
        possible.forEach(p => {
          if (j.toUpperCase().includes(p) && !result.includes(p)) {
            result.push(p);
          }
        });
      });
      return result;
    },
    syncDisplayedSegments() {
      // Show job types that are either in the enquiry OR already in the assignment
      this.displayedSegments = this.showSegmentArray.filter(seg => 
        this.enquiryJobTypes.includes(seg.value) || 
        this.newJobType.includes(seg.value)
      );
    },
    syncCheckboxes() {
      this.checkboxFlags = this.displayedSegments.map(seg => this.newJobType.includes(seg.value));
    },
    toggleJob(value) {
      let i = this.newJobType.indexOf(value);
      if (i >= 0) {
        this.newJobType.splice(i, 1);
        if (!this.minusJob.includes(value)) {
          this.minusJob.push(value);
        }
      } else {
        this.newJobType.push(value);
        let mIndex = this.minusJob.indexOf(value);
        if (mIndex >= 0) {
          this.minusJob.splice(mIndex, 1);
        }
      }
      this.syncCheckboxes();
    },
    SaveMultiUpdate() {
      if (this.selectedColumnName === "JOB CHANGE" && this.newJobType.length === 0) {
        this.showAlert("Please select at least one job type.");
        return;
      }
      if (this.selectedColumnName === "CLIENT" && !this.multiUpdateDetail.clientId) return this.showAlert("Please select Client.");
      if (this.selectedColumnName === "Importer Client" && !this.multiUpdateDetail.importerClientId) return this.showAlert("Please select Importer Client.");
      if (this.selectedColumnName === "Exporter Client" && !this.multiUpdateDetail.exporterClientId) return this.showAlert("Please select Exporter Client.");
      if (this.selectedColumnName === "Airline" && !this.multiUpdateDetail.airlineId) return this.showAlert("Please select Airline.");
      if (this.selectedColumnName === "Airport of Departure" && !this.multiUpdateDetail.airportDeparture) return this.showAlert("Please select Airport of Departure.");
      if (this.selectedColumnName === "Airport of Destination" && !this.multiUpdateDetail.airportDestination) return this.showAlert("Please select Airport of Destination.");
      if (this.selectedColumnName === "ENQUIRY ID" && !this.multiUpdateDetail.mainEnquiryId) return this.showAlert("Please select ENQUIRY ID.");
      if (this.selectedColumnName === "Booking No (CT JOB)" && !this.multiUpdateDetail.validBookingNo) return this.showAlert("Please enter Booking No.");

      let payload = {
        filter: "SubmitAssignmentMultiUpdate",
        allModuleId: this.mu_all_module_id,
        multiUpdateDetail: {
          ColumnName: this.selectedColumnName,
          jobType: this.newJobType,
          clientId: this.multiUpdateDetail.clientId,
          importerClientId: this.multiUpdateDetail.importerClientId,
          exporterClientId: this.multiUpdateDetail.exporterClientId,
          airlineId: this.multiUpdateDetail.airlineId,
          airportDeparture: this.multiUpdateDetail.airportDeparture,
          airportDestination: this.multiUpdateDetail.airportDestination,
          mainEnquiryId: this.multiUpdateDetail.mainEnquiryId,
          validBookingNo: this.multiUpdateDetail.validBookingNo,
          allModuleId: this.mu_all_module_id,
          shipmentType: 2, // Air
        },
      };


      this.isLoading = true;
      AirExpImpService.multiUpdateAirAssignment(payload)
        .then((result) => {
          const { data } = result;
          if (data && (data.success || data.find === 2)) {
            this.showAlert(data.message || data.MSG || "Assignment updated successfully.");
            this.$emit("refresh");
            this.hideModal();
          } else {
            this.showAlert(data.message || data.MSG || "Failed to update assignment.");
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("Error saving job types:", error);
          this.showAlert("An error occurred while saving.");
        }).finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 10px;
  border-top: 1px solid #dee2e6;
}
</style>



// WEBPACK FOOTER //
// AirAssignmentModal.vue?022f4314